export type RouteBindingMode =  'none' | 'two-way' | 'route-to-model' | 'model-to-route';

export class RouteBindingModeKey {
  static readonly NONE: RouteBindingMode = 'none';
  static readonly TWO_WAY: RouteBindingMode = 'two-way';
  static readonly ROUTE_TO_MODEL: RouteBindingMode = 'route-to-model';
  static readonly MODEL_TO_ROUTE: RouteBindingMode = 'model-to-route';
}
